import axiosInstance from "./axios";

const path = "common";

export const LogoutUser = async (dataOptions, data={}) => {
    return await axiosInstance(dataOptions).post(`${path}/logout`, data);
}